import React from 'react';
import { Briefcase, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function EmployeeRedirect() {
  // Production URL for when deployed
  const prodUrl = 'employee.zenstudios.in';
  // Preview URL (current environment) - uses relative path
  const previewUrl = `/api/employee-portal`;
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-emerald-500/20">
          <Briefcase className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-2">
          <span className="text-white">Zen</span>
          <span className="text-emerald-500">Studios</span>
        </h1>
        
        <h2 className="text-xl text-slate-300 mb-4">Employee Portal</h2>
        
        <p className="text-slate-400 mb-8">
          The Employee Dashboard has been moved to a dedicated portal for team members. Please access it through the secure employee URL.
        </p>
        
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-6">
          <p className="text-slate-300 text-sm mb-2">Production URL:</p>
          <p className="text-emerald-400 font-mono text-lg mb-4">{prodUrl}</p>
          <p className="text-slate-400 text-xs">Preview environment available below</p>
        </div>
        
        <div className="flex flex-col gap-3">
          <Button 
            className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700"
            onClick={() => window.open(previewUrl, '_blank')}
          >
            Open Employee Portal <ExternalLink className="w-4 h-4 ml-2" />
          </Button>
        </div>
        
        <p className="text-slate-500 text-sm mt-6">
          If you're a customer looking to log in, please use the main login page.
        </p>
      </div>
    </div>
  );
}
